import { useEffect, useState } from 'react';

import { gql, useQuery } from '@apollo/client';
import { ProjectStatusesEnum } from '@thinknet-gmbh/platform-common';

export const GET_PROJECTS = gql`
  query getProjects($payload: GetProjectsInput!) {
    getProjects(payload: $payload) {
      collection {
        _id
        createdAt
        createdBy
        name
        startDate
        projectNumber
        plannedHours
        status
      }
      totalCount
    }
  }
`;

export const useGetProjects = ({
  searchParam,
  projectStatuses,
  customerId,
}: {
  searchParam?: string;
  projectStatuses?: ProjectStatusesEnum[];
  customerId?: string;
}) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>();

  const pageSize = 12;
  const { data, loading } = useQuery(GET_PROJECTS, {
    variables: {
      payload: {
        queryOptions: {
          limit: pageSize,
          skip: pageSize * currentPage - pageSize,
          sort: currentNameSort,
        },
        searchQuery: {
          searchParam,
        },
        projectStatuses:
          projectStatuses && projectStatuses.length > 0
            ? projectStatuses
            : [ProjectStatusesEnum.ACTIVE],
        customerId,
      },
    },
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getProjects || {};

  useEffect(() => setPage(1), [searchParam]);

  return {
    loading,
    projects: collection,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'startDate', sortBy }]);
      }
    },
  };
};
